<template>
  <div id="paramc_common">
    <div id="prodcut_input_area">
      <div id="reference_image">
        <ul class="ul_tab small_text bold" v-if="targetPlan.inputReferenceList && targetPlan.inputReferenceList.length > 1">
          <li v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRef-' + index"
            @click="tabType=inputRef.tabId" v-bind:class="{active: tabType==inputRef.tabId, tab_title: true}">{{inputRef.tabName}}</li>
        </ul>
        <div v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRefImage-' + index">
          <div class="img_field" v-if="tabType==inputRef.tabId">
            <img :src="getImage('top/item/input/' + inputRef.img)" width="100%" height="100%">
          </div>
        </div>
      </div>
      <div class="product_input_size_area">
        <div class="product_input_size2">
          <div>
            <div>
              <div class="size_title">W1</div>
              <div>
                <template v-if="isDisableWidth"><div class="fixed_size">{{paramForm.width}}</div></template>
                <template v-else>
                  <input type="text" v-model="paramForm.width" @keypress="validateNumber" @input="paramForm.width=inputRestNumber($event)" @blur="onBlurStorageItemW" @focus="selectedAll">
                </template>
              </div>
            </div>
            <div class="small_text">{{paramForm.minWidth}}mm ～ {{paramForm.maxWidth}}mm</div>
          </div>
          <div>
            <div>
              <div class="size_title">W2</div>
              <div>
                <template v-if="isDisableWidth2"><div class="fixed_size">{{paramForm.width2}}</div></template>
                <template v-else>
                  <input type="text" v-model="paramForm.width2" @keypress="validateNumber" @input="paramForm.width2=inputRestNumber($event)" @blur="onBlurStorageItemW2" @focus="selectedAll">
                </template>
              </div>
            </div>
            <div class="small_text">{{paramForm.minWidth2}}mm ～ {{paramForm.maxWidth2}}mm</div>
          </div>
        </div>
        <div class="product_input_size2">
          <div>
            <div>
              <div class="size_title">H</div>
              <div class="size_comb">
                <template v-if="isDisableHeight"><div class="fixed_size">{{paramForm.height}}</div></template>
                <template v-else>
                  <input type="text" v-model="paramForm.height" @keypress="validateNumber" @input="paramForm.height=inputRestNumber($event)" @blur="onBlurStorageItemH" @focus="selectedAll">
                </template>
              </div>
            </div>
            <div class="small_text">{{paramForm.minHeight}}mm ～ {{paramForm.maxHeight}}mm</div>
          </div>
        </div>
        <div class="product_input_size2">
          <div>
            <div>
              <div class="size_title">D1</div>
              <div>
                <template v-if="isDisableDepth"><div class="fixed_size">{{paramForm.depth}}</div></template>
                <template v-else>
                  <input type="text" v-model="paramForm.depth" @keypress="validateNumber" @input="paramForm.depth=inputRestNumber($event)" @blur="onBlurStorageItemD" @focus="selectedAll">
                </template>
              </div>
            </div>
            <div class="small_text">{{paramForm.minDepth}}mm ～ {{paramForm.maxDepth}}mm</div>
          </div>
          <div>
            <div>
              <div class="size_title">D2</div>
              <div>
                <template v-if="isDisableDepth2"><div class="fixed_size">{{paramForm.depth2}}</div></template>
                <template v-else>
                  <input type="text" v-model="paramForm.depth2" @keypress="validateNumber" @input="paramForm.depth2=inputRestNumber($event)" @blur="onBlurStorageItemD2" @focus="selectedAll">
                </template>
              </div>
            </div>
            <div class="small_text">{{paramForm.minDepth2}}mm ～ {{paramForm.maxDepth2}}mm</div>
          </div>
        </div>
      </div>
    </div>
    <div class="errors_field">
      <div v-if="errors.width" class="error_text">{{errors.width}}</div>
      <div v-if="errors.height" class="error_text">{{errors.height}}</div>
      <div v-if="errors.depth" class="error_text">{{errors.depth}}</div>
      <div v-if="errors.width2" class="error_text">{{errors.width2}}</div>
      <div v-if="errors.depth2" class="error_text">{{errors.depth2}}</div>
    </div>
  </div>
</template>
<script>
import * as Check from '../../../../../utils/Check'
import * as App from '../../../../../utils/App'
import * as FormUtil from '../../../../../utils/FormUtil'

// const MIN_BURY_SIZE = 0
// const MAX_BURY_SIZE = 300

export default {
  components: {
  },
  props: {
    targetPlan: Object
  },
  data () {
    return {
      paramForm: {
        width: '',
        width2: '',
        height: '',
        height2: '',
        depth: '',
        depth2: '',
        minWidth: '',
        maxWidth: '',
        minWidth2: '',
        maxWidth2: '',
        minHeight: '',
        maxHeight: '',
        minDepth: '',
        maxDepth: '',
        minDepth2: '',
        maxDepth2: ''
      },
      errors: {},
      warns: {},
      tabType: 1
    }
  },
  watch: {
    targetPlan: function (plan) {
      console.log('param size watch')
      this.paramForm.width = plan.dcWidth
      this.paramForm.width2 = plan.dcWidth2
      this.paramForm.height = plan.dcHeight
      this.paramForm.height2 = plan.dcHeight2
      this.paramForm.depth = plan.dcDepth
      this.paramForm.depth2 = plan.dcDepth2
      this.paramForm.minWidth = plan.dcMinWidth
      this.paramForm.maxWidth = plan.dcMaxWidth
      this.paramForm.minWidth2 = plan.dcMinWidth2
      this.paramForm.maxWidth2 = plan.dcMaxWidth2
      this.paramForm.minHeight = plan.dcMinHeight
      this.paramForm.maxHeight = plan.dcMaxHeight
      this.paramForm.minHeight2 = plan.dcMinHeight2
      this.paramForm.maxHeight2 = plan.dcMaxHeight2
      this.paramForm.minDepth = plan.dcMinDepth
      this.paramForm.maxDepth = plan.dcMaxDepth
      this.paramForm.minDepth2 = plan.dcMinDepth2
      this.paramForm.maxDepth2 = plan.dcMaxDepth2
    }
  },
  computed: {
    itemWidth: function () {
      let size = Number(this.paramForm.width)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemHeight: function () {
      let size = Number(this.paramForm.height)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemDepth: function () {
      let size = Number(this.paramForm.depth)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemWidth2: function () {
      let size = Number(this.paramForm.width2)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemDepth2: function () {
      let size = Number(this.paramForm.depth2)
      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    isDisableWidth: function () {
      return this.paramForm.minWidth === this.paramForm.maxWidth
    },
    isDisableHeight: function () {
      return this.paramForm.minHeight === this.paramForm.maxHeight
    },
    isDisableDepth: function () {
      return this.paramForm.minDepth === this.paramForm.maxDepth
    },
    isDisableWidth2: function () {
      return this.paramForm.minWidth2 === this.paramForm.maxWidth2
    },
    isDisableDepth2: function () {
      return this.paramForm.minDepth2 === this.paramForm.maxDepth2
    },
    // isLeftFiller: function () {
    //   if (!this.paramForm.fillerTypeLeft) return false
    //   if (Number(this.paramForm.fillerTypeLeft) === 3) {
    //     return true
    //   }
    //   return false
    // },
    // isRightFiller: function () {
    //   if (!this.paramForm.fillerTypeRight) return false
    //   if (Number(this.paramForm.fillerTypeRight) === 3) {
    //     return true
    //   }
    //   return false
    // },
    // isCenterFiller: function () {
    //   if (!this.paramForm.fillerTypeCounter) return false
    //   if (Number(this.paramForm.fillerTypeCounter) === 3) {
    //     return true
    //   }
    //   return false
    // },
    isEnableHeight2: function () {
      if (this.paramForm.minHeight2 === undefined && this.paramForm.maxHeight2 === undefined) return false
      if (this.paramForm.minHeight2 === 0 && this.paramForm.maxHeight2 === 0) return false
      return true
    }
  },
  methods: {
    getParam: function () {
      let param = {
        width: this.paramForm.width,
        width2: this.paramForm.width2,
        height: this.paramForm.height,
        height2: this.isEnableHeight2 ? this.paramForm.height2 : undefined,
        depth: this.paramForm.depth,
        depth2: this.paramForm.depth2,
        minWidth: this.paramForm.minWidth,
        maxWidth: this.paramForm.maxWidth,
        minWidth2: this.paramForm.minWidth2,
        maxWidth2: this.paramForm.maxWidth2,
        minHeight: this.paramForm.minHeight,
        maxHeight: this.paramForm.maxHeight,
        minDepth: this.paramForm.minDepth,
        maxDepth: this.paramForm.maxDepth,
        minDepth2: this.paramForm.minDepth2,
        maxDepth2: this.paramForm.maxDepth2
      }
      return param
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    onBlurStorageItemW: function () {
      if (!this.paramForm.width || this.paramForm.width <= 0) {
        this.paramForm.width = 0
      }
      // 計算後の値をチェックする。
      let ret = this.validateItemW()
      if (!ret) {
        return false
      }
      ret = this.validateItemW2()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemH: function () {
      if (!this.paramForm.height || this.paramForm.height <= 0) {
        this.paramForm.height = 0
      }
      // 計算前の値をチェックする
      let ret = this.validateItemH()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemD: function () {
      // 商品サイズ
      if (!this.paramForm.depth || this.paramForm.depth <= 0) {
        this.paramForm.depth = 0
      }
      let ret = this.validateItemD()
      if (!ret) {
        return false
      }
      ret = this.validateItemD2()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemW2: function () {
      if (!this.paramForm.width2 || this.paramForm.width2 <= 0) {
        this.paramForm.width2 = 0
      }
      // 計算後の値をチェックする。
      let ret = this.validateItemW2()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemD2: function () {
      // 商品サイズ
      if (!this.paramForm.depth2 || this.paramForm.depth2 <= 0) {
        this.paramForm.depth2 = 0
      }
      let ret = this.validateItemD2()
      if (!ret) {
        return false
      }
    },
    selectedAll: function (event) {
      event.target.select()
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    checkParam: function () {
      let isCheckW = this.validateItemW()
      let isCheckH = this.validateItemH()
      let isCheckD = this.validateItemD()
      let isCheckW2 = this.validateItemW2()
      let isCheckD2 = this.validateItemD2()
      return isCheckW && isCheckH && isCheckD && isCheckW2 && isCheckD2
    },
    validateItemW: function () {
      let ret = true
      // 商品サイズのチェック
      if (this.itemWidth < this.paramForm.minWidth) {
        this.errors['width'] = 'Wの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemWidth > this.paramForm.maxWidth) {
        this.errors['width'] = 'Wの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.width
      }
      this.$forceUpdate()
      return ret
    },
    validateItemH: function () {
      let ret = true
      if (this.itemHeight < this.paramForm.minHeight) {
        this.errors['height'] = 'Hの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemHeight > this.paramForm.maxHeight) {
        this.errors['height'] = 'Hの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }
      if (ret) {
        delete this.errors.height
      }
      this.$forceUpdate()
      return ret
    },
    validateItemD: function () {
      let ret = true
      if (this.itemDepth < this.paramForm.minDepth) {
        this.errors['depth'] = 'Dの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemDepth > this.paramForm.maxDepth) {
        this.errors['depth'] = 'Dの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.depth
      }
      this.$forceUpdate()
      return ret
    },
    validateItemW2: function () {
      let ret = true
      // 商品サイズのチェック
      if (this.itemWidth2 < this.paramForm.minWidth2) {
        this.errors['width2'] = 'W2の商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemWidth2 > this.paramForm.maxWidth2) {
        this.errors['width2'] = 'W2の商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      } else if (this.itemWidth < this.itemWidth2) {
        this.errors['width2'] = 'W2の商品サイズはWより小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.width2
      }
      this.$forceUpdate()
      return ret
    },
    validateItemD2: function () {
      let ret = true
      if (this.itemDepth2 < this.paramForm.minDepth2) {
        this.errors['depth2'] = 'D2の商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemDepth2 > this.paramForm.maxDepth2) {
        this.errors['depth2'] = 'D2の商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      } else if (this.itemDepth < this.itemDepth2) {
        this.errors['depth2'] = 'D2の商品サイズはDより小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.depth2
      }
      this.$forceUpdate()
      return ret
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  }
}
</script>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/paramater/DcParamSizeShapedL.vue